import { BROWSER } from '@/constants';
import { browserAxios } from '@/lib/axios';
import { convertObjectToSneakJson } from '@/utils';

/**
 * リクエストパラメータ
 */
export type GuestSurviveApiRequest = {
  // 共有画面のURLキー
  urlKey: string;
  // ゲストID
  guestId: string;
};

/**
 * 結果コード定数
 */
export const GUEST_SURVIVE_API_RESULT_CODE = {
  // 成功
  OK: 'OK',
  // 入力パラメータエラー
  WARN_INPUT_PARAM: 'WARN_INPUT_PARAM',
  // URLキーが無効
  WARN_INVALID_URLKEY: 'WARN_INVALID_URLKEY',
  // Firestoreに利用者登録されていない
  WARN_UNREGISTER_SESSION: 'WARN_UNREGISTER_SESSION',
  // 不明なエラー
  ERR_UNKNOWN: 'ERR_UNKNOWN',
} as const;
export type GuestSurviveApiResultCode =
  (typeof GUEST_SURVIVE_API_RESULT_CODE)[keyof typeof GUEST_SURVIVE_API_RESULT_CODE];

/**
 * 結果コードのTypeGuard
 *
 * @param resultCode
 * @returns
 */
export const isGuestSurviveApiResultCode = (
  resultCode: string,
): resultCode is GuestSurviveApiResultCode => {
  if (resultCode in GUEST_SURVIVE_API_RESULT_CODE) {
    return true;
  }

  return false;
};

/**
 * レスポンス
 */
export type GuestSurviveApiResponse = {
  // 結果コード
  resultCode: GuestSurviveApiResultCode;
};

/**
 * API 呼び出し
 *
 * @returns
 */
const callApi = (
  request: GuestSurviveApiRequest,
): Promise<GuestSurviveApiResponse> => {
  // パラメータをスネークケースのJSONに変換
  const params = convertObjectToSneakJson(request);

  // リクエスト送信(POST)
  const response = browserAxios
    .post<GuestSurviveApiResponse>(BROWSER.API_URL.GUEST_SURVIVE, params, {
      headers: { 'Content-Type': 'application/json' },
    })
    .then((apiResponse) => apiResponse.data);

  return response;
};

/**
 * ゲスト生存受信API(同通サーバ) リクエスト
 *
 * @returns
 */
export const guestSurviveApi = (
  request: GuestSurviveApiRequest,
): Promise<GuestSurviveApiResponse> => callApi(request);
